import { useEffect, useState } from "react";

const useMinWait = (waitTime = 500): boolean => {
  const [isWaiting, setIsWaiting] = useState(true);

  useEffect(() => {
    setTimeout(() => setIsWaiting(false), waitTime);
  }, [waitTime]);

  return isWaiting;
};

export default useMinWait;
